import { getLayout } from '@/Utils/auth'
import React from 'react'
import ReactTimeago from 'react-timeago'
// @ts-ignore
import arStrings from "react-timeago/lib/language-strings/ar";
// @ts-ignore
import buildFormatter from "react-timeago/lib/formatters/buildFormatter";

const arFormatter = buildFormatter(arStrings);

const AlignTimeAgo = ({ date, classNames }: any) => {
    const local = getLayout()?.isEqual("RTL") ? "ar" : "en-US";
    const formatter = getLayout()?.isEqual("RTL") ? arFormatter : undefined;

    return (
        <ReactTimeago date={date} formatter={formatter} local={local} className={classNames} />
    )
}

export default AlignTimeAgo